import React from 'react';
import appletvplus from '../assets/chaine/appletvplus.svg'
import disneyplus from '../assets/chaine/disn.svg'
import hbomax from '../assets/chaine/hbomax.svg'
import hulu from '../assets/chaine/Hulu.svg'
import netflix from '../assets/chaine/netfli.svg'
import beinsport from '../assets/chaine/beinsport.webp'
import bbc from '../assets/chaine/BBC_Logo_2021.svg.png'
import discovery from '../assets/chaine/Discovery_logo_2021.svg.png'
import espn from '../assets/chaine/ESPN_wordmark.svg.png'
import fubotv from '../assets/chaine/FUBOTV.png'
import nlziet from '../assets/chaine/NLZIET.png'
import npo from '../assets/chaine/NPO.png'
import sbs from '../assets/chaine/SBS.png'
import rtl from '../assets/chaine/RTR.png'
import primevideo from '../assets/chaine/PRIMEVIDEO.png'
import talpanetwork from '../assets/chaine/TALPANETWORK.png'
import spi from '../assets/chaine/SPI.png'
import skyshowtime from '../assets/chaine/SKYSHOWTIME.png'
import viaplay from '../assets/chaine/VIAPLAY.png'
import ziggosport from '../assets/chaine/ZIGGOSPORT.png'
import vtm from '../assets/chaine/VTM.png'
import vrt from '../assets/chaine/VRT.png'
import paramount from '../assets/chaine/PARAMOUNT.png'

import film1 from '../assets/film/0TJcQq9zB6Ws.webp'
import film2 from '../assets/film/0ubiTyrUFFop.webp'
import film3 from '../assets/film/0YD2Lxd1rupt.jpg'
import film4 from '../assets/film/4vwxzJqdTjKc.webp'
import film5 from '../assets/film/4yDiSLPVCNo2.jpg'
import film6 from '../assets/film/9adl5jrt8vOt.webp'
import film7 from '../assets/film/9bShXLx0QMYy.webp'
import film8 from '../assets/film/CthYPvQStK0p.webp'
import film9 from '../assets/film/EiNN7a2t2W0f.webp'
import film10 from '../assets/film/FgQPg6ZdzUGk.webp'
import film11 from '../assets/film/g9tfwJuE8LCB.webp'
import film12 from '../assets/film/gBQgOZPulVNB.webp'
import film13 from '../assets/film/Gy4ZefHA8bk3.webp'
import film14 from '../assets/film/hLNumCs0mhhM.webp'
import film15 from '../assets/film/HuMzrgRuoP7l.jpg'
import film16 from '../assets/film/IUomaspDOSO3.webp'
import film17 from '../assets/film/jkrWTrr6QxJU.webp'
import film18 from '../assets/film/koymsEcGyZ2y.webp'
import film19 from '../assets/film/MhOZixp9FenH.webp'
import film20 from '../assets/film/NmYAYpMg94Wa.webp'
import film21 from '../assets/film/OybhtrgFUnmu.jpg'
import film22 from '../assets/film/PUQmGwTP2nQr.webp'
import film23 from '../assets/film/Q8iZb4XIlOOZ.webp'
import film24 from '../assets/film/QAoEfF0sJAkK.jpg'
import film25 from '../assets/film/sgemlsTPYTjj.webp'
import film26 from '../assets/film/t8zI9qCTuj7m.webp'
import film27 from '../assets/film/TD4HXJw2nH5k.webp'
import film28 from '../assets/film/uBBmdaaiQHhp.webp'
import film29 from '../assets/film/uTy0Os4JUvHs.webp'
import film30 from '../assets/film/UVa1dYkE2mTa.webp'
import film31 from '../assets/film/UxY1WNoDlAce.webp'
import film32 from '../assets/film/vwmd8cNyEiek.webp'
import film33 from '../assets/film/WETfcD0rs9zc.webp'
import film34 from '../assets/film/wqd8jfpK2Sw4.webp'
import film35 from '../assets/film/x8uc62lB5oaL.webp'
import film36 from '../assets/film/Z0HsztCaAltg.webp'
import film37 from '../assets/film/Z9OLc9CcKyez.webp'
import film38 from '../assets/film/odyssey.jpg'

export default function Series(){

    // Channel logos data
    const channels = [
        { name: "Netflix", logo: netflix },
        { name: "Disney+", logo: disneyplus },
        { name: "HBO Max", logo: hbomax },
        { name: "Prime Video", logo: primevideo },
        { name: "Apple TV+", logo: appletvplus },
        { name: "Hulu", logo: hulu },
        { name: "SkyShowtime", logo: skyshowtime },
        { name: "Viaplay", logo: viaplay },
        { name: "Paramount+", logo: paramount },
        { name: "NPO", logo: npo },
        { name: "RTL", logo: rtl },
        { name: "SBS6", logo: sbs },
        { name: "VTM", logo: vtm },
        { name: "VRT", logo: vrt },
        { name: "Talpa Network", logo: talpanetwork },
        { name: "NLZIET", logo: nlziet },
        { name: "Ziggo Sport", logo: ziggosport },
        { name: "beIN Sports", logo: beinsport },
        { name: "ESPN", logo: espn },
        { name: "BBC", logo: bbc },
        { name: "Discovery", logo: discovery },
        { name: "fuboTV", logo: fubotv },
        { name: "SPI International", logo: spi }
    ];

    // Film posters data
    const films = [
        { id: 1, poster: film1 },
        { id: 2, poster: film2 },
        { id: 3, poster: film3 },
        { id: 4, poster: film4 },
        { id: 5, poster: film5 },
        { id: 6, poster: film6 },
        { id: 7, poster: film7 },
        { id: 8, poster: film8 },
        { id: 9, poster: film9 },
        { id: 10, poster: film10 },
        { id: 11, poster: film11 },
        { id: 12, poster: film12 },
        { id: 13, poster: film13 },
        { id: 14, poster: film14 },
        { id: 15, poster: film15 },
        { id: 16, poster: film16 },
        { id: 17, poster: film17 },
        { id: 18, poster: film18 },
        { id: 19, poster: film19 },
        { id: 20, poster: film20 },
        { id: 21, poster: film21 },
        { id: 22, poster: film22 },
        { id: 23, poster: film23 },
        { id: 24, poster: film24 },
        { id: 25, poster: film25 },
        { id: 26, poster: film26 },
        { id: 27, poster: film27 },
        { id: 28, poster: film28 },
        { id: 29, poster: film29 },
        { id: 30, poster: film30 },
        { id: 31, poster: film31 },
        { id: 32, poster: film32 },
        { id: 33, poster: film33 },
        { id: 34, poster: film34 },
        { id: 35, poster: film35 },
        { id: 36, poster: film36 },
        { id: 37, poster: film37 },
        { id: 38, poster: film38 }
    ];


    return(
        <>
        <section className="series-section relative overflow-hidden">
            {/* Background Pattern */}
            <div className="absolute inset-0 opacity-20">
                    <div className="h-64 w-full" style={{
                        backgroundImage: `radial-gradient(circle, #3b82f6 1px, transparent 1px)`,
                        backgroundSize: '20px 20px'
                    }}></div>
                </div>
            <div className="main-content w-[90%] sm:w-[90%] md:w-[85%] m-auto">
            <div className="text-center mt-12">
                <h1 className="text-2xl md:text-3xl lg:text-4xl mx-auto font-extrabold text-blue-900 mb-4 max-w-3xl leading-snug text-center">
                    Onbeperkt streamen van de nieuwste films, series en live tv-kanalen
                </h1>
                <p className="text-lg text-gray-600 max-w-2xl mx-auto">
                    Geniet van premium content van de beste streamingplatforms in één abonnement
                </p>
            </div>
            {/* Films Carousel - Left to Right */}
            <div className="mt-5">
                <div className="relative overflow-hidden">
                    <div className="flex space-x-6 pb-5 carousel-films">
                        {[...films, ...films, ...films].map((film, index) => (
                            <div key={`${index}-${Math.random()}`} className="flex-shrink-0 carousel-item">
                                <div className="relative w-48 h-80 rounded-lg overflow-hidden shadow-lg">
                                    <img
                                        src={film.poster}
                                        alt={film.id}
                                        className="w-full h-full object-cover carousel-image"
                                    />
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
            {/* Channels Carousel - Right to Left */}
            <div className="mt-5">
                <div className="relative overflow-hidden">
                    <div className="flex space-x-8 carousel-channels">
                        {[...channels, ...channels, ...channels].map((channel, index) => (
                            <div key={`${index}-${Math.random()}`} className="flex-shrink-0 flex items-center justify-center carousel-item">
                                <div className="w-24 h-16 flex items-center justify-center p-2">
                                    <img
                                        src={channel.logo}
                                        alt={channel.name}
                                        className="max-w-full max-h-full object-contain carousel-image"
                                    />
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
            </div>
        </section>
        </>
    )
}